__turbopack_context__.v({
  "banner-img": "signup-module__e4896a__banner-img",
  "buttonBox": "signup-module__e4896a__buttonBox",
  "card-footer-text": "signup-module__e4896a__card-footer-text",
  "cardContainer": "signup-module__e4896a__cardContainer",
  "container": "signup-module__e4896a__container",
  "content": "signup-module__e4896a__content",
  "darkBG": "signup-module__e4896a__darkBG",
  "divider": "signup-module__e4896a__divider",
  "errorMsg": "signup-module__e4896a__errorMsg",
  "form-group": "signup-module__e4896a__form-group",
  "illustration": "signup-module__e4896a__illustration",
  "inputBox": "signup-module__e4896a__inputBox",
  "intro": "signup-module__e4896a__intro",
  "large-4": "signup-module__e4896a__large-4",
  "left": "signup-module__e4896a__left",
  "lightBG": "signup-module__e4896a__lightBG",
  "newLetterContainer": "signup-module__e4896a__newLetterContainer",
  "newsletter-bridge": "signup-module__e4896a__newsletter-bridge",
  "newsletter-card": "signup-module__e4896a__newsletter-card",
  "newsletter-columns": "signup-module__e4896a__newsletter-columns",
  "newsletter-grid": "signup-module__e4896a__newsletter-grid",
  "newsletter-header": "signup-module__e4896a__newsletter-header",
  "newsletter-promo": "signup-module__e4896a__newsletter-promo",
  "newsletter-promo__container": "signup-module__e4896a__newsletter-promo__container",
  "newsletter-section": "signup-module__e4896a__newsletter-section",
  "overlay": "signup-module__e4896a__overlay",
  "right": "signup-module__e4896a__right",
  "submit-btn": "signup-module__e4896a__submit-btn",
  "textCenter": "signup-module__e4896a__textCenter",
});
